import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AppContextProps {
    // Add your state and methods here
    onlineCourse: boolean;
    setOnlineCourse: (onlineCourse: boolean) => void;
    tab: number;
    setTab: (tab: number) => void;
    openPopUp: boolean;
    setOpenPopUp: (openPopUp: boolean) => void;
    step: number;
    setStep: (step: number) => void;
    bank: number;
    setBank: (bank: number) => void;
    currencyData: boolean;
    setCurrencyData: (currencyData: boolean) => void;
    officialCourse: boolean;
    setOfficialCourse: (officialCourse: boolean) => void;
    currentRateData: any;
    setCurrentRateData: (data: any) => void;
    currencyBuyRates: { [key: string]: number };
    setCurrencyBuyRates: React.Dispatch<React.SetStateAction<{ [key: string]: number }>>;
    currencySellRates: { [key: string]: number };
    setCurrencySellRates: React.Dispatch<React.SetStateAction<{ [key: string]: number }>>;
    currence: any;
    setCurrence: React.Dispatch<React.SetStateAction<any>>;
    sellAmount: string | number;
    setSellAmount: React.Dispatch<React.SetStateAction<string | number>>;
    buyAmount: string | number;
    setBuyAmount: React.Dispatch<React.SetStateAction<string | number>>;
    sellCurrencyInfo: string;
    setSellCurrencyInfo: React.Dispatch<React.SetStateAction<string>>;
    buyCurrencyInfo: string;
    setBuyCurrencyInfo: React.Dispatch<React.SetStateAction<string>>;
    createOrder: object;
    setCreateOrder: React.Dispatch<React.SetStateAction<object>>;
    isCash: boolean;
    setIsCash: React.Dispatch<React.SetStateAction<boolean>>;
    showDropdown: boolean;
    setShowDropdown: React.Dispatch<React.SetStateAction<boolean>>;
    buyCurrencyForInfo: string | number;
    setBuyCurrencyForInfo: React.Dispatch<React.SetStateAction<string | number>>;
    showPopUpCalculate: boolean;
    setShowPopUpCalculate: React.Dispatch<React.SetStateAction<boolean>>;
    tableTitle: string;
    setTableTitle: React.Dispatch<React.SetStateAction<string>>;
    city: number | null;
    setCity: React.Dispatch<React.SetStateAction<number | null>>;
    product: number | null;
    setProduct: React.Dispatch<React.SetStateAction<number | null>>;
    selectDisabled: boolean;
    setSelectDisabled: React.Dispatch<React.SetStateAction<boolean>>;
    showOnlineTab: boolean;
    setShowOnlineTab: React.Dispatch<React.SetStateAction<boolean>>;
    showVerification: boolean;
    setShowVerification: React.Dispatch<React.SetStateAction<boolean>>;
    popupContent: "Calculate" | "Dialog" | "Verification" | "OTP" | "ErrorMessage" | null;
    setPopupContent: React.Dispatch<React.SetStateAction<"Calculate" | "Dialog" | "Verification" | "OTP" | "ErrorMessage" | null>>;
    errorMsg: { title: string; message: string, link: string };
    setErrorMsg: React.Dispatch<React.SetStateAction<{ title: string; message: string, link: string }>>;
    resHeaderHash: { 'X-Verification-Hash': string | null };
    setResHeaderHash: React.Dispatch<React.SetStateAction<{ 'X-Verification-Hash': string | null }>>;

}

const AppContext = createContext<AppContextProps | undefined>(undefined);

export const AppProvider = ({ children }: { children: ReactNode }) => {
    const [onlineCourse, setOnlineCourse] = useState<boolean>(false);
    const [tab, setTab] = React.useState(0);
    const [openPopUp, setOpenPopUp] = useState<boolean>(false);
    const [step, setStep] = useState<number>(1);
    const [bank, setBank] = React.useState<number>(0);
    const [currencyData, setCurrencyData] = React.useState<boolean>(false);
    const [officialCourse, setOfficialCourse] = React.useState<boolean>(false);

    const [currentRateData, setCurrentRateData] = React.useState<any>([{
        sourceCurrency: null,
        targetCurrency: null,
        buy: null,
        sell: null,
        nbgRate: null,
        buyIBAN: null,
        sellIBAN: null,
        code: null,
        amount: null,
        name: null,
    }]);

    const [currencyBuyRates, setCurrencyBuyRates]: [{ [key: string]: number }, React.Dispatch<React.SetStateAction<{ [key: string]: number }>>] = React.useState({});
    const [currencySellRates, setCurrencySellRates]: [{ [key: string]: number }, React.Dispatch<React.SetStateAction<{ [key: string]: number }>>] = React.useState({});
    const [currence, setCurrence] = React.useState<any>([]);
    const [sellAmount, setSellAmount] = useState<string | number>('');
    const [buyAmount, setBuyAmount] = useState<string | number>('');
    const [sellCurrencyInfo, setSellCurrencyInfo] = useState<string>("GEL");
    const [buyCurrencyInfo, setBuyCurrencyInfo] = useState<string>("USD");
    const [createOrder, setCreateOrder] = React.useState<object>({
        sourceCurrency: "USD",
        targetCurrency: "GEL",
        amount: null,
        result: null,
        openBankingLinkProvider: null,
        bankAccount: [],
        isChecked: false,
    });

    const [isCash, setIsCash] = React.useState<boolean>(true);
    const [showDropdown, setShowDropdown] = React.useState<boolean>(true);
    const [buyCurrencyForInfo, setBuyCurrencyForInfo] = React.useState<string | number>("0.0000");
    const [showPopUpCalculate, setShowPopUpCalculate] = useState<boolean>(false);
    const [tableTitle, setTableTitle] = useState<string>("");
    const [city, setCity] = useState<number | null>(null);
    const [product, setProduct] = useState<number | null>(null);
    const [selectDisabled, setSelectDisabled] = useState<boolean>(true);
    const [showOnlineTab, setShowOnlineTab] = useState<boolean>(false);
    const [showVerification, setShowVerification] = useState<boolean>(true);
    const [popupContent, setPopupContent] = React.useState<"Calculate" | "Dialog" | "Verification" | "OTP" | "ErrorMessage" | null>(null);
    const [errorMsg, setErrorMsg] = React.useState({ title: "", message: "", link: "" });
    const [resHeaderHash, setResHeaderHash] = React.useState<{ 'X-Verification-Hash': string | null }>({
        'X-Verification-Hash': null
    });

    return (
        <AppContext.Provider value={{
            onlineCourse,
            setOnlineCourse,
            tab,
            setTab,
            openPopUp,
            setOpenPopUp,
            step,
            setStep,
            bank,
            setBank,
            currencyData,
            setCurrencyData,
            officialCourse,
            setOfficialCourse,
            currentRateData,
            setCurrentRateData,
            currencyBuyRates,
            setCurrencyBuyRates,
            currencySellRates,
            setCurrencySellRates,
            currence,
            setCurrence,
            sellAmount,
            setSellAmount,
            buyAmount,
            setBuyAmount,
            sellCurrencyInfo,
            setSellCurrencyInfo,
            buyCurrencyInfo,
            setBuyCurrencyInfo,
            createOrder,
            setCreateOrder,
            isCash,
            setIsCash,
            showDropdown,
            setShowDropdown,
            buyCurrencyForInfo,
            setBuyCurrencyForInfo,
            showPopUpCalculate,
            setShowPopUpCalculate,
            tableTitle,
            setTableTitle,
            city,
            setCity,
            product,
            setProduct,
            selectDisabled,
            setSelectDisabled,
            showOnlineTab,
            setShowOnlineTab,
            showVerification,
            setShowVerification,
            popupContent,
            setPopupContent,
            errorMsg,
            setErrorMsg,
            resHeaderHash,
            setResHeaderHash,
        }}>
            {children}
        </AppContext.Provider>
    );
};

export const useAppContext = () => {
    const context = useContext(AppContext);
    if (context === undefined) {
        throw new Error('useAppContext must be used within an AppProvider');
    }
    return context;
};